<template>
  <div class="tab-list">
    <div class="tab">
      <div
        v-for="(item, key) in typeList"
        :key="key"
        class="tab__item"
        :class="getTabClass(key, item)"
        @click="changeTab(item)"
      >
        <div class="image"></div>
        <div class="tab__seperator" v-if="key != typeList.length - 1"></div>
      </div>
    </div>
    <div class="list">
      <template v-if="loading">
        <loader width="100%" height="300px" background="#fffcf1" />
      </template>
      <template v-else-if="newsList.length > 0">
        <div
          v-for="(item, key) in newsList"
          :key="key"
          class="list__item"
          @click="viewNews(item)"
        >
          <div class="content">
            <div class="left">
              <div class="tag">{{ item.tag }}</div>
            </div>
            <div class="right">
              <div class="top">
                <span>{{ item.time }}</span>
                <span>{{ item.title }}</span>
              </div>
              <div class="bottom">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="empty">暂无数据</div>
      </template>
    </div>
    <pagination :startHeight="440" :total="total" :pageNum="currentPage" @change="changePage" v-if="newsList.length > 0" />
  </div>
</template>

<script>
import Loader from '@/components/loader/Index.vue'
import Pagination from './Pagination.vue'

import { getNewsData } from '@/api/system.api.js'

export default {
  components: {
    Loader,
    Pagination,
  },
  data() {
    return {
      activeTab: 'last',
      typeList: [],
      newsList: [],
      total: 0,
      currentPage: 1,
      loading: false
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    async getNewsList() {
      // const params = {

      // }
      this.typeList = [
        "last",
        "news",
        "strategy",
        "activity",
      ]
      this.loading = true
      const data = await this.getListByType(this.activeTab)
      this.loading = false
      this.newsList = data.list
      this.total = data.total
      // await getNewsList(params)
      //   .then((res) => {
      //     if (res.code == 0) {
      //       this.typeList = res.data.type
      //       this.newsList = res.data.list
      //       this.total = res.data.total
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
      // let data = {}
      // switch (this.activeTab) {
      //   case 'latest':
      //     data = require('@/mock/temp/newsListLatest')
      //     break
      //   case 'news':
      //     data = require('@/mock/temp/newsListNews')
      //     break
      //   case 'tips':
      //     data = require('@/mock/temp/newsListTips')
      //     break
      //   case 'activity':
      //     data = require('@/mock/temp/newsListActivity')
      //     break
      // }
      // this.typeList = data.type
      // this.newsList = data.list
      // this.total = data.total
    },
    async getListByType(type) {
      const list = await getNewsData({
        page: this.currentPage,
        limit: 10,
      }, type)
        .then((res) => {
          let list = []
          for (let i = 0; i < res.list.length; i++) {
            list.push({
              id: res.list[i].id,
              tag: res.list[i].tag,
              title: res.list[i].title,
              time: new Date(res.list[i].createtime * 1000).toLocaleDateString('zh-cn'),
              description: res.list[i].desc,
            })
          }

          return {
            list: list,
            total: res.total,
          }
        })
        .catch(() => {
          return {
            list: [],
            total: 0,
          }
        })

      return list
    },
    // 获取当前选中的新闻类型的className
    getTabClass(key, item) {
      let className = 'tab__type-' + item

      return className + (this.activeTab == item ? ' tab--active' : '')
    },
    // 切换分类
    changeTab(key) {
      this.activeTab = key
      this.currentPage = 1
      this.getNewsList()
    },
    // 跳转到新闻详情页
    viewNews(item) {
      this.$router.push({ name: 'PcNews', query: { id: item.id } })
    },
    // 切换页码
    changePage(page) {
      this.currentPage = page
      this.getNewsList()
    },
  }
}
</script>

<style lang="scss" scoped>
.tab {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 48px auto 10px;
  width: 393px;

  &__item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    cursor: pointer;

    .image {
      width: 90px;
      height: 48px;
      background: url('~@/assets/img/pc/news_type.png') no-repeat;
    }
  }

  &--active {
    background: url('~@/assets/img/pc/news_type_active.png') no-repeat;
    background-position: left bottom;
  }

  &__seperator {
    transform: rotate(45deg);
    margin-left: 4px;
    width: 7px;
    height: 7px;
    background: #9a7b62;
  }

  &__type {
    &-last .image {
      background-position: 0 0;
    }
    &-news .image {
      background-position: 0 -48px;
    }
    &-strategy .image {
      background-position: 0 -96px;
    }
    &-activity .image {
      background-position: 0 -144px;
    }
  }
}

.list {
  margin-bottom: 100px;
  width: 100%;
  min-height: 500px;
  border-top: 1px solid #c3ad99;

  &__item {
    border-bottom: 1px solid #e8e1da;
    cursor: pointer;

    .content {
      display: flex;
      margin: 0 auto;
      padding-top: 50px;
      width: 1000px;
      height: 152px;
    }

    .left {
      margin-right: 35px;

      .tag {
        width: 62px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 20px;
        color: #fff;
        background: #388176;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 854px;

      .top {
        display: flex;
        align-items: center;
        margin-bottom: 7px;
        height: 32px;
        font-size: 20px;
        font-weight: bold;
        color: #3a3a3a;

        span:first-of-type {
          margin-right: 25px;
          width: 110px;
        }

        span:last-of-type {
          flex: 1;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .bottom {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #8e8e8e;
      }
    }

    &:hover {
      background: url('~@/assets/img/pc/list_item_bg.jpg') no-repeat;

      .bottom {
        color: #3a3a3a;
      }
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    font-size: 30px;
    color: #3a3a3a;
  }
}
</style>